var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"src":_vm.frameUrl,"width":"100%","height":"700px","id":"iframe","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }